import { useEffect, useState } from "react";

import PaymentMethodSelection from "features/payment-methods/components/PaymentMethod/PaymentMethodSelection";
import usePaymentSources from "features/payment-methods/datahooks/usePaymentSources";
import type {
  MixpanelPaymentMethodSource,
  PaymentSource,
} from "features/payment-methods/types";

import Loader from "common/components/Loader";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

import AddPaymentMethod from "./AddPaymentMethod";

export interface PaymentMethodProps {
  initialPaymentSource: PaymentSource;
  onBack: () => void;
  setPaymentSource: (paymentSource: PaymentSource) => void;
  mixpanelSource: MixpanelPaymentMethodSource;
  isSettingPaymentSource?: boolean;
  setPaymentSourceError?: Error;
}

export default function PaymentMethod({
  initialPaymentSource,
  onBack,
  setPaymentSource,
  mixpanelSource,
  isSettingPaymentSource,
  setPaymentSourceError,
}: PaymentMethodProps) {
  const { role } = useSelectedWorkspaceContext();
  const { paymentSources, isLoadingPaymentSources } = usePaymentSources();
  const [isAddingPaymentMethod, setIsAddingPaymentMethod] = useState(false);

  useEffect(() => {
    //automatically go to new payment source if there are no payment sources added
    if (
      role === "owner" &&
      !isLoadingPaymentSources &&
      paymentSources &&
      !paymentSources.length
    ) {
      setIsAddingPaymentMethod(true);
    }
  }, [paymentSources, isLoadingPaymentSources]);

  if (isLoadingPaymentSources) return <Loader className="my-40" />;

  if (isAddingPaymentMethod)
    return (
      <AddPaymentMethod
        mixpanelSource={mixpanelSource}
        setPaymentSource={setPaymentSource}
        onBack={
          paymentSources.length ? () => setIsAddingPaymentMethod(false) : onBack
        }
      />
    );

  return (
    <PaymentMethodSelection
      selectedPaymentSource={initialPaymentSource}
      addPaymentMethod={() => setIsAddingPaymentMethod(true)}
      onBack={onBack}
      setPaymentSource={setPaymentSource}
      isSettingPaymentSource={isSettingPaymentSource}
      setPaymentSourceError={setPaymentSourceError}
    />
  );
}
